import { Box, SystemProps, Flex, css } from "@storyofams/react-ui";
import Head from "next/head";
import Image from "next/image";
import { NODE_PARAGRAPH } from "storyblok-rich-text-react-renderer";

import { getLinkProps } from "~lib";

import { Button } from "../../Button";
import { Heading } from "../../Heading";
import { RichText } from "../../RichText";
import { Text } from "../../Text";
import { Container } from "../molecules/Container";

type ImageBannerProps = {
  first?: boolean;
  content: {
    title?: string;
    text?: any;
    image: any;
    button_label?: any;
    button_url?: any;
    alternative_colours?: boolean;
    height?: number;
  };
} & SystemProps;

export const ImageBanner = ({ content, first, ...props }: ImageBannerProps) => {
  return (
    <>
      <Head>
        <link
          rel="preload"
          href={content?.image?.filename + "/m/1300x500"}
          as="image"
        />
      </Head>
      <Container width="calc(100% - 32px)" maxWidth={"1332px"} px={2}>
        <Flex
          px={{ all: 2, md: 8, lg: 10 }}
          py={[5, 10]}
          alignItems="flex-start"
          flexDirection="column"
          zIndex={1}
          position="relative"
          height={content?.height ? content?.height + "px" : "100%"}
        >
          <Box
            css={css({
              "&&": {
                position: "absolute",
                top: "0",
                bottom: "0",
                left: "0",
                right: "0",
                zIndex: -1,
              },
              "> div": { height: "100%" },
              img: {
                // width: '100%',
                // maxWidth: '100%',
                borderRadius: "md",
              },
            })}
            {...props}
          >
            <Image
              alt={content?.image?.alt || ""}
              src={content?.image?.filename + "/m/1300x500"}
              priority={true}
              layout="fill"
              objectFit="cover"
            />
          </Box>
          <Box
            height={content?.height ? content?.height + "px" : "100%"}
            css={{
              position: "absolute",
              top: "0",
              bottom: "0",
              left: "0",
              width: "100%",
              maxWidth: "720px",
              background: content?.alternative_colours
                ? "linear-gradient(90deg, rgba(29, 29, 27, 0.6) 0%, rgba(255, 255, 255, 0) 100%)"
                : "linear-gradient(90deg, rgba(255, 255, 255, 0.6) 0%, rgba(255, 255, 255, 0) 100%)",
              zIndex: -1,
              borderRadius: "8px 0 0 8px",
            }}
          />
          <Heading
            width="100%"
            maxWidth="720px"
            lineHeight="medium"
            as={first ? "h1" : "h2"}
            variant={"h1"}
            mb={2}
            color={content?.alternative_colours && "white"}
            {...props}
          >
            {content?.title}
          </Heading>
          {!!content?.text?.content?.[0]?.content?.[0]?.text && (
            <RichText
              mb={[6]}
              maxWidth="480px"
              width="100%"
              text={content?.text}
              color={content?.alternative_colours && "white"}
              nodeResolvers={{
                [NODE_PARAGRAPH]: (children) => (
                  <Text as="p" pb={["12px", "16px"]}>
                    {children}
                  </Text>
                ),
              }}
            />
          )}

          {content?.button_label && getLinkProps(content?.button_url) && (
            <Button
              variant={content?.alternative_colours ? "secondary" : "primary"}
              borderColor={content?.alternative_colours && "white"}
              bg={content?.alternative_colours && "white"}
              href={getLinkProps(content?.button_url)}
            >
              {content?.button_label}
            </Button>
          )}
        </Flex>
      </Container>
    </>
  );
};
